import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { useValue } from '@morningtrain/react-resources'

export default function InventoryDeliveryNoteItemCalculator ({ inventoryItemId }) {
  const pricePerUnit = useValue('price')

  function generatePath (name) {
    return ['globals.inventory.order_items', inventoryItemId, name].join('.')
  }

  const [price] = useEnvValue(generatePath('price'), pricePerUnit)
  const [total] = useEnvValue(generatePath('total'))
  const [received] = useEnvValue(generatePath('received'))
  const [receivedOffset, setReceivedOffset] = useEnvValue(generatePath('received_offset'), 0)
  const [receivedPrice, setReceivedPrice] = useEnvValue(generatePath('received_price'), 0)
  const [receivedOffsetPrice, setReceivedOffsetPrice] = useEnvValue(generatePath('received_offset_price'), 0)

  function calculateOffset (received, total) {
    if (received === null) {
      return 0
    }
    return received - total
  }

  function calculateReceivedPrice (received, pricePerUnit) {
    if (received === null) {
      return 0
    }
    return received * pricePerUnit
  }

  React.useEffect(() => {
    const offset = calculateOffset(received, total)
    setReceivedOffset(offset)
    setReceivedOffsetPrice(offset * price)
    setReceivedPrice(calculateReceivedPrice(received, price))
  }, [])

  React.useEffect(() => {
    const offset = calculateOffset(received, total)
    setReceivedOffset(offset)
    setReceivedOffsetPrice(offset * price)
    setReceivedPrice(calculateReceivedPrice(received, price))
  }, [total, received, price])

  return null
}
